import { NgModule } from "@angular/core";

import {
  LucideAngularModule,
  Check,
  Link2,
  Power,
  User,
  Lock,
  X,
  MoreHorizontal,
  RotateCcw,
  Unlink,
  Bell,
  AlertTriangle,
  ChevronLeft,
  ChevronDown,
  Lightbulb,
  CircleFadingArrowUp,
  ArrowBigUpDash,
  Play,
  Share,
  Download,
  Gamepad2,
  Monitor,
} from "lucide-angular";

// Select some icons (use an object, not an array)
const icons = {
  User,
  Power,
  Link2,
  Check,
  Lock,
  X,
  MoreHorizontal,
  RotateCcw,
  Unlink,
  Bell,
  AlertTriangle,
  ChevronLeft,
  ChevronDown,
  Lightbulb,
  CircleFadingArrowUp,
  ArrowBigUpDash,
  Play,
  Share,
  Download,
  Gamepad2,
  Monitor,
};

@NgModule({
  imports: [LucideAngularModule.pick(icons)],
  exports: [LucideAngularModule],
})
export class IconModule {}
